export const state = {
  deadstocks: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/deadstocks/state.js